import React from "react";

function FlightRescheduleQueues() {
  return <div>FlightRescheduleQueues</div>;
}

export default FlightRescheduleQueues;
